export default __webpack_public_path__ + "static/media/center.af71eaa5.svg";